import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { CvLayout } from './CvLayout';
import { DynamicPageComponent } from './types';

const StyledContent = styled('div')(() => ({
  textAlign: 'center',
}));

const StyledSVG = styled('svg')(() => ({
  height: '200px',
  marginTop: '150px',
}));

const StyledLanding = styled(Typography)(() => ({
  fontSize: '20px',
}));

const StyledInfoLanding = styled('div')(() => ({
  fontSize: '12px',
  marginTop: '10px',
}));

const StyledInfoCaseDetails = styled('div')(() => ({
  fontSize: '12px',
}));

export const Landing: DynamicPageComponent = () => {
  return (
    <CvLayout
      headerTitle="Connected Vehicle Portal"
      viewActiveCase="VIEW ACTIVE CASE"
    >
      <Fragment>
        <StyledContent>
          <StyledSVG
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 500 351"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="CV_Icon_Red"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g transform="translate(46.000000, 71.000000)">
                <path
                  d="M330.64047,167.100915 C334.4231,167.096874 337.835517,169.372362 339.285871,172.865895 C340.736224,176.359429 339.938748,180.382669 337.265455,183.058825 C334.592162,185.73498 330.569777,186.536761 327.074694,185.090146 C323.57961,183.643532 321.30047,180.233551 321.30047,176.45092 C321.30047,171.29096 325.480514,167.106439 330.64047,167.100915 M330.64047,162.100916 C322.715184,162.100916 316.29047,168.525634 316.29047,176.45092 C316.29047,184.376206 322.715184,190.80092 330.64047,190.80092 C338.565757,190.80092 344.990474,184.376206 344.990474,176.45092 C344.993126,172.64425 343.482108,168.992728 340.790385,166.301005 C338.098662,163.609282 334.447141,162.098264 330.64047,162.100916 L330.64047,162.100916 Z"
                  id="Shape"
                  fill="#CE0E2D"
                  fillRule="nonzero"
                />
                <path
                  d="M73.6404704,167.10092 C78.8043329,167.10092 82.9904704,171.287057 82.9904704,176.45092 C82.9904704,181.614782 78.8043329,185.80092 73.6404704,185.80092 C68.476608,185.80092 64.2904704,181.614782 64.2904704,176.45092 C64.2904704,173.971146 65.2755569,171.592937 67.029022,169.839471 C68.7824872,168.086006 71.1606963,167.10092 73.6404704,167.10092 M73.6404704,162.10092 C65.7151843,162.10092 59.2904704,168.525634 59.2904704,176.45092 C59.2904704,184.376206 65.7151843,190.80092 73.6404704,190.80092 C81.5657566,190.80092 87.9904704,184.376206 87.9904704,176.45092 C87.9904704,168.525634 81.5657566,162.10092 73.6404704,162.10092 L73.6404704,162.10092 Z"
                  id="Shape"
                  fill="#CE0E2D"
                  fillRule="nonzero"
                />
                <circle
                  id="Oval"
                  stroke="#CE0E2D"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  cx="330.63047"
                  cy="176.45092"
                  r="28.17"
                />
                <circle
                  id="Oval"
                  stroke="#CE0E2D"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  cx="73.6104704"
                  cy="176.45092"
                  r="28.17"
                />
                <path
                  d="M92.1904704,87.2009199 C92.1904704,87.2009199 81.6304704,101.36092 84.9804704,109.73092 L116.79047,111.41092 L183.49047,114.76092 L175.96047,77.0409199"
                  id="Path"
                  stroke="#CE0E2D"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="183.49047"
                  y1="114.76092"
                  x2="281.16047"
                  y2="122.85092"
                  id="Path"
                  stroke="#CE0E2D"
                  strokeWidth="5"
                  strokeLinejoin="round"
                />
                <path
                  d="M401.43047,139.49092 C386.29047,118.28092 297.82047,114.76092 297.82047,114.76092 C297.82047,114.76092 286.727596,108.696815 273.448934,101.914378 C269.732591,100.016154 261.610633,105.428401 257.747131,103.534836 C252.74638,101.083886 252.020329,91.3682723 247.523603,89.3755962 C241.885222,86.8770088 236.975928,84.9384526 233.63047,84.0609199 C188.53047,72.2409199 134.09047,78.2909199 116.98047,80.7109199 C99.8704704,83.1309199 39.2104704,105.27092 28.6404704,108.06092 C18.4304704,110.75092 7.43047044,108.90092 8.64047044,114.76092 C9.85047044,120.62092 8.64047044,141.13092 4.32047044,146.29092 C1.65047044,149.48092 -0.569529558,154.17092 0.130470442,161.43092 C0.830470442,168.69092 2.50047044,177.43092 2.50047044,177.43092 L46.3104704,183.49092 C43.3182621,172.071839 47.7631285,159.998234 57.4453498,153.245211 C67.1275711,146.492188 79.9933698,146.492188 89.6755911,153.245211 C99.3578124,159.998234 103.802679,172.071839 100.81047,183.49092 L101.73047,183.49092 L304.02047,185.86092 C299.834684,174.025056 303.98632,160.847767 314.200718,153.548825 C324.415116,146.249883 338.226728,146.591104 348.068237,154.385536 C357.909747,162.179968 361.405614,175.546193 356.64047,187.16092 C382.16047,187.16092 407.72047,184.71092 403.07047,177.83092 C401.00047,174.77092 403.63047,157.73092 403.81047,151.41092 C404.18047,140.62092 401.43047,139.49092 401.43047,139.49092 Z"
                  id="Path"
                  stroke="#CE0E2D"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  id="Oval"
                  stroke="#CE0E2D"
                  strokeWidth="10"
                  cx="263"
                  cy="91"
                  r="13"
                />
                <path
                  d="M319,90 C313.936972,61.3479544 286.492088,31.1980325 240,39.3553233"
                  id="Oval-Copy"
                  stroke="#CE0E2D"
                  strokeWidth="12"
                />
                <path
                  d="M354,78 C346.373414,35.0219316 305.032386,-10.2029513 235,2.03298496"
                  id="Oval-Copy-2"
                  stroke="#CE0E2D"
                  strokeWidth="12"
                />
              </g>
            </g>
          </StyledSVG>
          <StyledLanding variant="h6">No Active Case</StyledLanding>
          <StyledInfoLanding>
            Currently there are no active cases for programs configured for
            Connected Vehicle Portal.
          </StyledInfoLanding>
          <StyledInfoCaseDetails>
            The screen will populate the case details when there is an active
            case.
          </StyledInfoCaseDetails>
        </StyledContent>
      </Fragment>
    </CvLayout>
  );
};
